<template><div><h1>禁用 eslint</h1>
<p>并不推荐禁用<code>eslint</code>, 编码规范可以一定程序上保证代码质量。但是如果你确实想禁用，可以删除<code>build/webpack.base.conf.js</code>里的相关代码。</p>
<pre class="hljs"><code>preLoaders: [
  {
   <span class="hljs-attr">test</span>: <span class="hljs-regexp">/\.vue$/</span>,
   <span class="hljs-attr">loader</span>: <span class="hljs-string">'eslint'</span>,
   <span class="hljs-attr">include</span>: [
     path.join(projectRoot, <span class="hljs-string">'src'</span>)
   ],
   <span class="hljs-attr">exclude</span>: <span class="hljs-regexp">/node_modules/</span>
  },
  {
   <span class="hljs-attr">test</span>: <span class="hljs-regexp">/\.js$/</span>,
   <span class="hljs-attr">loader</span>: <span class="hljs-string">'eslint'</span>,
   <span class="hljs-attr">include</span>: [
     path.join(projectRoot, <span class="hljs-string">'src'</span>)
   ],
   <span class="hljs-attr">exclude</span>: <span class="hljs-regexp">/node_modules/</span>
  }
]
</code></pre>
<p>如果你只是想禁用对某一文件的检测，那么可以在<code>.eslintignore</code>里添加规则。</p>
<p>如果你是想禁止某一行的检测，那么可以使用<code>// eslint-disable-line</code>。</p>
<p>更加灵活的使用参考 <a href="http://eslint.org/docs/user-guide/configuring#disabling-rules-with-inline-comments">eslint文档</a>。</p>
</div></template><script>
export default {
  head: {"title":"vue-loader 禁用 eslint | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-loader-disable-eslint-160.vue?10943faf